import { Injectable } from '@angular/core';

import { MaterialCodigoBarra } from "./material-codigo-barra.model";
import {
  materiaisRouter, materialCodigoBarraRouter,
  materialCodigoBarraStorageName, materialCodigoBarraApi
} from "../../material/shared/data.service";
import { RestService } from "../../../../core/services/rest.service";
import { AuthService } from "../../../../shared/services/auth.service";
import { almoxarifadoRoute } from "../../../shared/data.service";
import { newRoute, editRoute } from "../../../../shared/services/data.service";

@Injectable()
export class MaterialCodigoBarraService {
    private apiUrl: string = materialCodigoBarraApi;
    private storageName: string = materialCodigoBarraStorageName;

    constructor(
        private _restService: RestService,
        private _authService: AuthService
    ){}

    onPost(object: MaterialCodigoBarra, done: any) {
        this._restService.onPost(this.apiUrl, object, done);
    }

    onPut(object: MaterialCodigoBarra, done: any) {
        this._restService.onPut(this.apiUrl, object, done);
    }

    onDelete(objectId: number, done: any) {
        this._restService.onDelete(this.apiUrl, objectId, done);
    }

    onGetbyMaterial(materialId: number, done: any) {
        var filter: any = {"order":"codigoBarra","where":{"materialId":materialId}};
        this._restService.onGetPost(this.apiUrl, filter, done);
    }

    onGetById(objectId: number, done: any) {
        var filter: any = {"include":"material"};
        this._restService.onGetPostId(this.apiUrl, objectId, filter, done);
    }

    //storage
    setStorage(item: MaterialCodigoBarra) {
        var object: string = JSON.stringify(item);
        localStorage.setItem(this.storageName + '-selected', object);
    }

    getStorage() {
        var item: string = localStorage.getItem(this.storageName + "-selected");
        return JSON.parse(item);
    }

    //session
    setSessionStorage(item: any) {
        var object: string = JSON.stringify(item);
        sessionStorage.setItem(this.storageName + '-new', object);
    }

    getSessionStorage() {
        var item: string = sessionStorage.getItem(this.storageName + "-new");
        return JSON.parse(item);
    }

    //router
    goToList() {
        // var router: string =  this.moduleRouter + '/' + this.componentRouter;
        // this._authService.navigateTo(router);
    }

    goToAdd() {
        var router: string = almoxarifadoRoute + '/' + materiaisRouter + '/' + materialCodigoBarraRouter + '/' + newRoute;
        this._authService.navigateTo(router);
    }

    goToEdit(objectId: number) {
        var router: string = almoxarifadoRoute + '/' + materiaisRouter + '/' + materialCodigoBarraRouter + '/' + editRoute;
        this._authService.navigateTo(router, objectId);
    }

    //others
    //qndo retorna para continuar o cadastro, caso tenha ido para outro formulario
    returnToForm() {
        var session: any = this.getSessionStorage();
        if (session && session.id) {
            this.goToEdit(session.id);
        } else {
            this.goToAdd();
        }
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/almoxarifado/materiais/material-codigo-barra/shared/material-codigo-barra.service.ts
 **/